import React, { FC, useMemo, useState } from 'react'
import Touchable from '@components/Touchable'
import {
  Stack,
  Chip,
  Typography,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
} from '@mui/material'

interface DappUrl {
  logo: string
  title: string
  description?: string
  category: string
  url: string
}

const appUrls: DappUrl[] = [
  {
    title: 'KongSwap',
    description:
      'The one stop token shop - Trade tokens across all chains with ease using KongSwap.',
    logo: 'https://plug-cdn.s3.amazonaws.com/kong.jpg',
    category: 'DeFi',
    url: 'https://www.kongswap.io/',
  },
  {
    title: 'Funded',
    description: 'Web3 crowdfunding! You can participate in crowdfunding with ICP, BTC and ETH.',
    logo: 'https://plug-cdn.s3.amazonaws.com/funded_logo.png',
    category: 'Utility & NFTs',
    url: 'https://funded.app',
  },
  {
    title: 'Yumi',
    description:
      'Yumi is a high-speed, low-cost, and fully decentralized NFT marketplace built on the Internet Computer.',
    logo: 'https://internetcomputer.org/img/showcase/yumi_logo.webp',
    category: 'Utility & NFTs',
    url: 'https://tppkg-ziaaa-aaaal-qatrq-cai.raw.ic0.app/',
  },
  {
    title: 'ICPSwap',
    description: 'ICPSwap is DEX built completely end-to-end on-chain',
    logo: 'https://internetcomputer.org/img/showcase/icpswap_logo.webp',
    category: 'DeFi',
    url: 'https://icpswap.com/',
  },
  {
    title: 'Open Chat',
    description: 'OpenChat is a fully decentralized real-time messaging service.',
    logo: 'https://internetcomputer.org/img/showcase/openchat_logo.webp',
    category: 'Social',
    url: 'https://oc.app/',
  },
]

const dappTypes: string[] = ['All', 'DeFi', 'Social', 'Other']

const DappsTab: FC<{ searchTerm: string }> = ({ searchTerm }) => {
  const [selectedSection, setSelectedSection] = useState<string>('All')

  const dapps = useMemo(() => {
    if (selectedSection === 'All') return appUrls
    if (selectedSection === 'Other') {
      return appUrls.filter((dapp) => !['DeFi', 'Social'].includes(dapp.category))
    }

    return appUrls.filter((dapp) => dapp.category === selectedSection)
  }, [selectedSection])

  return (
    <>
      <Stack direction="row" spacing={1} mb={1}>
        {dappTypes.map((section) => (
          <Touchable onClick={() => setSelectedSection(section)}>
            <Chip label={section} color={section === selectedSection ? 'primary' : 'secondary'} />
          </Touchable>
        ))}
      </Stack>
      <Typography pb={1} variant="body2">
        {dapps
          .filter((dapp) => dapp.title.toLowerCase().includes(searchTerm.toLowerCase()))
          .map((app, index) => (
            <ListItem onClick={() => window.open(app.url)} key={`dapp-${index}`}>
              <ListItemAvatar>
                <Avatar src={app.logo} />
              </ListItemAvatar>
              <ListItemText primary={app.title} secondary={app.description} />
            </ListItem>
          ))}
      </Typography>
    </>
  )
}

export default DappsTab
